import React from "react";
import { Typography } from "@mui/material";

const regExp = /with Note\/Reason: "(.*?)". \(/;

function formatText(sentence: string): string {
  return sentence.replace(regExp, "to: ").slice(0, -1);
}
export default function ProjectText({ sentence }: { sentence: string }) {
  const sentenceFormated = formatText(sentence);
  return <Typography variant={"body1"}>{sentenceFormated}</Typography>;
}
